import React from 'react'
import styled from 'styled-components'
import { useIntl } from 'gatsby-plugin-intl'
import { EXCHANGE_MAP_TYPES } from './offerMapUtils'

const TYPE_LABELS = {
  [EXCHANGE_MAP_TYPES.EXPORT]: 'offers.mapRoundTripExport',
  [EXCHANGE_MAP_TYPES.GENERAL]: 'offers.mapRoundTripGeneral'
}

const RoundTripRefreshNotice = ({ failedExchangeTypes = [] }) => {
  const intl = useIntl()
  if (failedExchangeTypes.length === 0) return null

  const exchanges = failedExchangeTypes
    .map(type => intl.formatMessage({ id: TYPE_LABELS[type] }))
    .join(', ')

  return (
    <Notice role='status'>
      <span>
        {intl.formatMessage(
          {
            id: 'offers.mapRoundTripPartialError',
            defaultMessage:
              'Some offers could not be refreshed ({exchanges}). Results may be incomplete or out of date.'
          },
          { exchanges }
        )}
      </span>
    </Notice>
  )
}

const Notice = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  padding: 0.75rem;
  font-size: 0.8rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.ghost.hex()};
`

export default RoundTripRefreshNotice
